import Hades from '@adoratorio/hades';
import utils from '@/scripts/utils';

import aion from './aion';

const hades = {
  ref: null,
  init: () => {
    hades.ref = new Hades({
      mode: !utils.isTouchDevice() ? Hades.MODE.VIRTUAL : Hades.MODE.NATIVE,
      viewport: !utils.isTouchDevice() ? document.querySelector('.app__wrapper') : window,
      container: document.querySelector('.app__container'),
      easing: {
        mode: Hades.EASING.QUAD,
        duration: 800,
      },
      autoBoundries: true,
      smoothDirectionChange: true,
      aion,
      emitGlobal: true,
    });
  }
}

export default hades;
